export default Object.freeze({
  GALLERY_ITEMS_PER_PAGE: 10,
  FEED_ITEMS_PER_PAGE: 3
});
